import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const Footer = () => {
  const { currentUser } = useApp();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer" style={{
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1100,
      backgroundColor: '#f8f9fa',
      borderTop: '1px solid #dee2e6',
      padding: '0.55rem 1rem',
      textAlign: 'center',
      color: '#6c757d',
      fontSize: '0.9rem',
      boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.06)'
    }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', columnGap: '1rem', rowGap: '0.35rem', marginBottom: '0.3rem' }}>
        <Link to="/about" style={{ color: '#007bff', textDecoration: 'none', whiteSpace: 'nowrap' }}>About</Link>
        <Link to="/contact" style={{ color: '#007bff', textDecoration: 'none', whiteSpace: 'nowrap' }}>Contact Us</Link>
        <a href="/privacy-policy.html" style={{ color: '#007bff', textDecoration: 'none', whiteSpace: 'nowrap' }}>Privacy Policy</a>
        <a href="/terms-of-service.html" style={{ color: '#007bff', textDecoration: 'none', whiteSpace: 'nowrap' }}>Terms of Service</a>
        {currentUser && (
          <Link to="/user-manual" style={{ color: '#007bff', textDecoration: 'none', whiteSpace: 'nowrap' }}>User Manual</Link>
        )}
      </div>
      <div style={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
        © {currentYear} Real Air Adventures, LLC. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;